import { LOAD_DIRECT_MERCHANT, setDirectMerchant } from './reducer';
import { getRequest, handleSagaError } from '../../../../utilities/requests';
import { takeEvery, put } from 'redux-saga/effects';

function* handleLoadDirectMerchant(action) {
  try {
    const url = `/users/${action.id}`;
    const response = yield getRequest(url);
    yield put(setDirectMerchant(response.data));
  } catch (error) {
    yield handleSagaError(error);
  }
}

export function* loadDirectMerchantSaga() {
  yield takeEvery(LOAD_DIRECT_MERCHANT, handleLoadDirectMerchant);
}
